<template>
  <div class="day-picker-wrap">
    <div class="picker-wrap">
      <div class="year-month">
        <gs-button
          style="width:20px;"
          icon="arrow-left"
          @click="pre"
        />
        <span>{{ year }}年{{ month }}月</span>
        <gs-button
          style="width:20px;"
          icon="arrow-right"
          @click="next"
        />
      </div>
      <table>
        <thead>
          <tr>
            <th
              v-for="(item, key) in daysLabel"
              :key="key"
            >{{ item }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- 行数按处理过的周日所拥有的数组长度处理 -->
          <tr
            v-for="(item, index) in daysMap[0]"
            :key="index"
          >
            <!-- 列数为当前列[周几]的第几个 -->
            <td
              v-for="(item, key) in daysMap"
              :key="key"
              :class="{
                'is-disabled': isDisabledDate(daysMap[key][index]),
                'is-active': activeDate === daysMap[key][index]
              }"
            >
              <el-button
                v-show="daysMap[key][index]"
                :disabled="isDisabledDate(daysMap[key][index])"
                type="text"
                @click="dateChange(daysMap[key][index])"
              >
                {{ daysMap[key][index] }}
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="picker-footer margin-top24">
      <span class="margin-left24">
        <i class="icon-tip" />
        活动日
      </span>
      <span>
        <i class="icon-tip active-icon" />
        选定日期
      </span>
    </div>
    <div>
      <gs-button @click="today">今天</gs-button>
    </div>
  </div>
</template>

<script>
import exchangeTime from '../../utils/timeExchange.js'
export default {
  props: {
    year: {
      type: [String, Number],
      default: 1978
    },
    month: {
      type: [String, Number],
      default: 1
    },
    isDisabledDate: {
      type: Function,
      default () {
        return false
      }
    }
  },
  data () {
    //console.log(parseInt(exchangeTime(new Date()).substr(8, 2)))
    return {
      daysLabel: ['日', '一', '二', '三', '四', '五', '六'],
      activeDate: parseInt(exchangeTime(new Date()).substr(8, 2))
    }
  },

  computed: {
    daysMap () {
      // 保存当月日期对应的周几 0对应周日 以此类推
      let dateMap = {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: []
      }
      const year = parseInt(this.year, 10) || 1978
      const month = parseInt(this.month, 10) || 1

      // 计算一个月有多少天
      let newDate = new Date(year, month, 0)
      let days = newDate.getDate()

      // 计算第一天是星期几
      const firstDay = (new Date(`${year}-${month}-${1}`).getDay())

      for (let j = 0; j < firstDay; j++) {
        dateMap[j].push(0)
      }
      dateMap[firstDay].push(1)

      // 获取这个月的每个日期对应的周期
      for (let i = 2; i <= days; i++) {
        const nowDay = new Date(`${year}-${month}-${i}`)
        dateMap[nowDay.getDay()].push(i)
      }

      return dateMap
    }
  },
  watch: {
    activeDate () {
      let data = {
        year: this.year,
        month: this.month,
        day: this.activeDate
      }
      this.$emit('changeDate', data)
    }
  },
  methods: {
    clearDate () {
      this.activeDate = ''
      this.$emit('dateChange', this.activeDate)
    },
    dateChange (val) {
      // 如果选中的正是这个日期，则再次点击清空选项
      if (this.activeDate === val) {
        this.activeDate = ''
      } else {
        this.activeDate = val
      }
      this.$emit('dateChange', this.activeDate)
    },
    today () {
      this.year = parseInt(exchangeTime(new Date()).substr(0, 4))
      this.month = parseInt(exchangeTime(new Date()).substr(5, 2))
      this.activeDate = parseInt(exchangeTime(new Date()).substr(8, 2))
    },
    pre () {
      this.$emit('preMon', true)
      setTimeout(() => {
        if (this.year === parseInt(exchangeTime(new Date()).substr(0, 4)) && this.month === parseInt(exchangeTime(new Date()).substr(5, 2))) {
          this.activeDate = parseInt(exchangeTime(new Date()).substr(8, 2))
        } else {
          this.activeDate = ''
        }
      }, 0)
    },
    next () {
      this.$emit('nextMon', true)
      setTimeout(() => {
        if (this.year === parseInt(exchangeTime(new Date()).substr(0, 4)) && this.month === parseInt(exchangeTime(new Date()).substr(5, 2))) {
          this.activeDate = parseInt(exchangeTime(new Date()).substr(8, 2))
        } else {
          this.activeDate = ''
        }
      }, 0)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/datePicker/dayPicker.vue